import { AiScreeningResponseStatus, AiScreeningResult } from '@core/ai-screening-types';

export function getScreeningSummaryData(
  result: AiScreeningResult[],
  status: AiScreeningResponseStatus,
) {
  const resultsCount = result.length;
  const validCriteriaCount = result.filter(({ status }) => status === 'fulfilled').length;
  const unknownCount = result.filter(({ status }) => status === 'unverifiable').length;

  return {
    isAllValid: validCriteriaCount === resultsCount,
    resultsCount,
    validCriteriaCount,
    validPercent: validCriteriaCount / resultsCount,
    validXofY: `${validCriteriaCount}/${resultsCount}`,
    maybeValidXofY: `${validCriteriaCount}${unknownCount > 0 ? '?' : ''}/${resultsCount}`,
    unknownCount,
    screeningStatus: status,
  };
}
